export type PetSpecies =
  | 'egg1'
  | 'cat'
  | 'dog'
  | 'rabbit'
  | 'hamster'
  | 'fox'
  | 'penguin'
  | 'dragon'
  | 'unicorn'
  | 'phoenix'
  | 'robot'
  | 'custom';

export type PetMood = 'happy' | 'sad' | 'hungry' | 'sick' | 'sleepy';
export type DungeonDifficulty = 'easy' | 'normal' | 'hard';
export type OriginalPetForm =
  | 'starEgg'
  | 'mongsil'
  | 'starBean'
  | 'cloudBean'
  | 'flameBean'
  | 'starKeeper'
  | 'cloudGuardian'
  | 'flameDragon';

export interface PetNurtureTraits {
  bond: number;
  care: number;
  courage: number;
}

export interface PetAbilities {
  starlight: number;
  vitality: number;
  courage: number;
}

export interface VirtualPetClassSettings {
  enabled: boolean;
  freeChatPerDay: number;
  freeRestPerDay: number;
  freeStrokePerDay: number;
  interactionCooldownSec: number;
}

export interface PetProfile {
  name: string;
  petForm: OriginalPetForm;
  level: number;
  exp: number;
  intimacy: number;
  nurtureTraits: PetNurtureTraits;
  abilities: PetAbilities;
  /** 일일 놀아주기 사용 기록 (YYYY-MM-DD) */
  dailyActions?: {
    date: string;
    strokeCount: number;
    chatCount: number;
    restCount: number;
  };
  createdAt?: Date;
  updatedAt?: Date;
}

export interface PetStats {
  hunger: number;
  happiness: number;
  energy: number;
  health: number;
  mood: PetMood;
  lastUpdatedAt?: Date;
}

export interface PetInventoryItem {
  id: string;
  name: string;
  slot: 'hat' | 'accessory' | 'background' | 'consumable';
  image: string;
  price: number;
  effect?: {
    hunger?: number;
    happiness?: number;
    energy?: number;
    health?: number;
    intimacy?: number;
    exp?: number;
  };
}

export interface PetInventory {
  ownedItemIds: string[];
  /** 소모품 아이템 ID → 보유 수량 */
  consumables?: Record<string, number>;
  equipped: {
    hat?: string;
    accessory?: string;
    background?: string;
  };
}

export interface PetEvolutionState {
  dungeonClearCount: number;
  lastEvolvedAt?: Date;
  history: Array<{
    from: OriginalPetForm;
    to: OriginalPetForm;
    at: Date;
  }>;
}

export interface PetDungeonRun {
  id: string;
  difficulty: DungeonDifficulty;
  startedAt: Date;
  endsAt: Date;
  status: 'running' | 'completed' | 'claimed';
  rewardPoints: number;
  rewardExp: number;
}

export interface PetShareCard {
  id: string;
  ownerUid: string;
  ownerName: string;
  petName: string;
  petForm: OriginalPetForm;
  level: number;
  equipped: PetInventory['equipped'];
  createdAt: Date;
}

export const PET_SHOP_ITEMS: PetInventoryItem[] = [
  { id: 'hat-basic', name: '기본 모자', slot: 'hat', image: '🎩', price: 80 },
  { id: 'hat-crown', name: '왕관', slot: 'hat', image: '👑', price: 180 },
  { id: 'acc-glasses', name: '안경', slot: 'accessory', image: '👓', price: 90 },
  { id: 'acc-ribbon', name: '리본', slot: 'accessory', image: '🎀', price: 90 },
  { id: 'bg-space', name: '우주 배경', slot: 'background', image: '🌌', price: 140 }
];
